// On phones the top bar slides away while the page scrolls down and comes back when it scrolls
// up. It waits for a deliberate move each way, measured in distance (a delay in time would feel
// slow on a flick): a nudge down while reading leaves it, and scrolling back up, which is how
// people look for it, brings it back sooner. It always shows within its own height of the top.
export const TRAVEL = Object.freeze({ down: 24, up: 16 });

// A scroll lasts until the page rests this long (its glide after a flick included): the
// travel counts within one scroll, so separate nudges never add up to a turn.
export const REST_MS = 150;

// The page standing still at `y`, with the bar shown.
export const atRest = (y) => ({ hidden: false, anchor: y, y, at: -Infinity });

// The bar after the page scrolled to `y` (clamped to the page: iOS bounces past both ends) at
// `at` ms. `anchor` is the farthest the scroll got in its direction: where a turn is measured from.
export function followScroll(state, y, at, barHeight) {
  const anchor = at - state.at > REST_MS ? state.y : state.anchor;
  const next = (hidden, from) => ({ hidden, anchor: from, y, at });

  if (y <= barHeight) return next(false, y);
  if (state.hidden ? y > anchor : y < anchor) return next(state.hidden, y);
  if (Math.abs(y - anchor) < (state.hidden ? TRAVEL.up : TRAVEL.down)) return next(state.hidden, anchor);
  return next(!state.hidden, y);
}

// Where a scroll box is, within its range.
export function scrollPosition(el) {
  return Math.min(Math.max(el.scrollTop, 0), el.scrollHeight - el.clientHeight);
}
